export interface MappedValues {
  [key: string]: string;
}

export interface UpdatedMappedValues {
  [key: string]: {
    displayScope: string;
    officeBreadcrumb: string;
    officeUrl: string;
    searchUrl: string;
  };
}

export const mappedvalues: MappedValues = {
  Hypotheekadviseur: 'hypotheek',
  Verkoopmakelaar: 'verkoopmakelaar',
  Aankoopbemiddeling: 'aankoopbemiddeling',
  Uitvaartverzorging: 'uitvaartverzorging',
  Scheiding: 'scheiding',
  Taxatie: 'taxatie',
  Aansprakelijkheidsverzekering: 'aansprakelijkheidsverzekering',
  Betalingsrisicoverzekering: 'betalingsrisicoverzekering',
  Lenen: 'lenen',
  Vermogen: 'vermogen',
  'Zakelijke financiering': 'zakelijke-financiering',
  Belasting: 'belasting',
  'Duurzaam wonen': 'duurzaamwonen',
  Pensioenregeling: 'pensioenregeling',
  Notariaat: 'notariaat',
  Arbeidsongeschiktheidsverzekering: 'arbeidsongeschiktheidsverzekering',
  Bedrijfsschadeverzekering: 'bedrijfsschadeverzekering',
  Pensioen: 'pensioen',
  Verzuimverzekering: 'verzuimverzekering',
  Verzekering: 'verzekering',
  Bankzaken: 'bankzaken',
  Rechtsbijstandverzekering: 'rechtsbijstandverzekering',
  'Financiële planning': 'financieleplanning',
  Aankoopmakelaar: 'aankoopmakelaar',
};

export const slugMapped: MappedValues = {
  hypotheekadvies: 'hypotheek',
  risicoverzekeringadvies: 'risicoverzekering',
  verkoopmakelaar: 'verkoopmakelaar',
  aankoopbemiddelingad: 'aankoopbemiddeling',
  uitvaartverzorgingadvies: 'uitvaartverzorging',
  scheidingsadvies: 'scheiding',
  taxatie: 'taxatie',
  aansprakelijkheidsverzekeringsadvies: 'aansprakelijkheidsverzekering',
  betalingsrisicoverzekeringsadvies: 'betalingsrisicoverzekering',
  lenenadvies: 'lenen',
  vermogensadvies: 'vermogen',
  'zakelijke-financieringsadvies': 'zakelijke-financiering',
  belastingadvies: 'belasting',
  duurzaamwonen: 'duurzaamwonen',
  pensioenregelingsadvies: 'pensioenregeling',
  notariaat: 'notariaat',
  arbeidsongeschiktheidsverzekeringsadvies: 'arbeidsongeschiktheidsverzekering',
  bedrijfsschadeverzekeringsadvies: 'bedrijfsschadeverzekering',
  pensioenadvies: 'pensioen',
  verzuimverzekeringsadvies: 'verzuimverzekering',
  verzekeringsadvies: 'verzekering',
  bankzaken: 'bankzaken',
  rechtsbijstandverzekeringsadvies: 'rechtsbijstandverzekering',
  financieleplanningadvies: 'financieleplanning',
  aankoopmakelaar: 'aankoopmakelaar',
  rechtsbijstandverzekering: 'rechtsbijstandverzekering',
  pensioenregeling: 'pensioenregeling',
  aansprakelijkheidsverzekering: 'aansprakelijkheidsverzekering',
  arbeidsongeschiktheidsverzekering: 'arbeidsongeschiktheidsverzekering',
  bedrijfsschadeverzekering: 'bedrijfsschadeverzekering',
  betalingsrisicoverzekering: 'betalingsrisicoverzekering',
  verzuimverzekering: 'verzuimverzekering',
  'zakelijke-financiering': 'Zakelijke financiering',
};

export const scopeMapper: UpdatedMappedValues = {
  aankoopmakelaar: {
    displayScope: 'Aankoopmakelaars',
    officeUrl: 'aankoopmakelaar',
    officeBreadcrumb: 'Aankoopmakelaar',
    searchUrl: 'aankoopmakelaar',
  },
  bankzaken: {
    displayScope: 'Bankmedewerkers',
    officeUrl: 'bankzaken',
    officeBreadcrumb: 'Bankzaken',
    searchUrl: 'bankzaken',
  },
  belasting: {
    displayScope: 'Belastingadviseurs',
    officeUrl: 'belastingadvies',
    officeBreadcrumb: 'Belasting',
    searchUrl: 'belasting',
  },
  duurzaamwonen: {
    displayScope: 'Duurzaam wonen adviseurs',
    officeUrl: 'duurzaamwonen',
    officeBreadcrumb: 'Duurzaam wonen',
    searchUrl: 'duurzaamwonen',
  },
  financieleplanning: {
    displayScope: 'Financieel planners',
    officeUrl: 'financieleplanningadvies',
    officeBreadcrumb: 'Financiële planning',
    searchUrl: 'financieleplanning',
  },
  hypotheek: {
    displayScope: 'Hypotheekadviseurs',
    officeUrl: 'hypotheekadvies',
    officeBreadcrumb: 'Hypotheek',
    searchUrl: 'hypotheek',
  },
  risicoverzekering: {
    displayScope: 'Risicoadviseurs',
    officeUrl: 'risicoverzekeringadvies',
    officeBreadcrumb: 'Risicoverzekering',
    searchUrl: 'risicoverzekering',
  },
  lenen: {
    displayScope: 'Kredietadviseurs',
    officeUrl: 'lenenadvies',
    officeBreadcrumb: 'Lenen',
    searchUrl: 'lenen',
  },
  notariaat: {
    displayScope: 'Notarissen',
    officeUrl: 'notariaat',
    officeBreadcrumb: 'Notariaat',
    searchUrl: 'notariaat',
  },
  pensioen: {
    displayScope: 'Pensioenadviseurs',
    officeUrl: 'pensioenadvies',
    officeBreadcrumb: 'Pensioen',
    searchUrl: 'pensioen',
  },
  scheiding: {
    displayScope: 'Scheidingsadviseurs',
    officeUrl: 'scheidingsadvies',
    officeBreadcrumb: 'Scheiding',
    searchUrl: 'scheiding',
  },
  taxatie: {
    displayScope: 'Taxateurs',
    officeUrl: 'taxatie',
    officeBreadcrumb: 'Taxatie',
    searchUrl: 'taxatie',
  },
  verkoopmakelaar: {
    displayScope: 'Verkoopmakelaars',
    officeUrl: 'verkoopmakelaar',
    officeBreadcrumb: 'Verkoopmakelaar',
    searchUrl: 'verkoopmakelaar',
  },
  vermogen: {
    displayScope: 'Vermogensadviseurs',
    officeUrl: 'vermogensadvies',
    officeBreadcrumb: 'Vermogen',
    searchUrl: 'vermogen',
  },
  verzekering: {
    displayScope: 'Verzekeringsadviseurs',
    officeUrl: 'verzekeringsadvies',
    officeBreadcrumb: 'Verzekering',
    searchUrl: 'verzekering',
  },
  aansprakelijkheidsverzekering: {
    displayScope: 'Verzekeringsadviseurs',
    officeUrl: 'aansprakelijkheidsverzekeringsadvies',
    officeBreadcrumb: 'Aansprakelijkheidsverzekering',
    searchUrl: 'aansprakelijkheidsverzekering',
  },
  arbeidsongeschiktheidsverzekering: {
    displayScope: 'Verzekeringsadviseurs',
    officeUrl: 'arbeidsongeschiktheidsverzekeringsadvies',
    officeBreadcrumb: 'Arbeidsongeschiktheidsverzekering',
    searchUrl: 'arbeidsongeschiktheidsverzekering',
  },
  bedrijfsschadeverzekering: {
    displayScope: 'Verzekeringsadviseurs',
    officeUrl: 'bedrijfsschadeverzekeringsadvies',
    officeBreadcrumb: 'Bedrijfsschadeverzekering',
    searchUrl: 'bedrijfsschadeverzekering',
  },
  betalingsrisicoverzekering: {
    displayScope: 'Verzekeringsadviseurs',
    officeUrl: 'betalingsrisicoverzekeringsadvies',
    officeBreadcrumb: 'Betalingsrisicoverzekering',
    searchUrl: 'betalingsrisicoverzekering',
  },
  pensioenregeling: {
    displayScope: 'Pensioenadviseurs',
    officeUrl: 'pensioenregelingsadvies',
    officeBreadcrumb: 'Pensioenregeling',
    searchUrl: 'pensioenregeling',
  },
  rechtsbijstandverzekering: {
    displayScope: 'Verzekeringsadviseurs',
    officeUrl: 'rechtsbijstandverzekeringsadvies',
    officeBreadcrumb: 'Rechtsbijstandverzekering',
    searchUrl: 'rechtsbijstandverzekering',
  },
  verzuimverzekering: {
    displayScope: 'Verzekeringsadviseurs',
    officeUrl: 'verzuimverzekeringsadvies',
    officeBreadcrumb: 'Verzuimverzekering',
    searchUrl: 'verzuimverzekering',
  },
  'zakelijke-financiering': {
    displayScope: 'Financieringsadviseurs',
    officeUrl: 'zakelijke-financieringsadvies',
    officeBreadcrumb: 'Zakelijke financiering',
    searchUrl: 'zakelijke-financiering',
  },
  uitvaartverzorging: {
    displayScope: 'Uitvaartverzorging',
    officeUrl: 'uitvaartverzorgingadvies',
    officeBreadcrumb: 'Uitvaartverzorging',
    searchUrl: 'uitvaartverzorging',
  },
};

export function getKeyByValue(
  object: MappedValues,
  value: string
): string | undefined {
  if (slugMapped && Object.values(slugMapped).includes(value)) {
    return value;
  }

  return object[value];
}
